<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 900px;">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div class="col-6 pl-0">
            <h3 class="modal-title">
              貸款帳號 <span v-if="loan!==null">{{loan.account}}</span>
            </h3>
          </div>
          <div class="col-6 pr-0 text-right">
            <h4 class="my-1" v-if="loan!==null">{{loan.address}}</h4>
          </div>
        </div>
        <div class="modal-body">
          <h4>近6期繳費記錄</h4>
          <table class="table insurance-green">
            <thead>
              <tr>
                <th width="45">期數</th>
                <th class="text-right">繳款前<br/>本金餘額</th>
                <th>應繳日期</th>
                <th>實繳日期</th>
                <th class="text-right" width="100">適用年利率</th>
                <th class="text-right" width="80">本期本金</th>
                <th class="text-right" width="80">本期利息</th>
                <th class="text-right" width="70">延滯金</th>
                <th class="text-right" width="70">違約金</th>
                <th>繳款方式</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(record, i) in records"
              :key="`loan-record-${i}`">
                <td>{{record.series}}</td>
                <td class="text-right">{{record.last | numberFormat}}</td>
                <td>{{record.shouldPayAt | dateFormat}}</td>
                <td>{{record.payAt | dateFormat}}</td>
                <td class="text-right">{{record.rate}}%</td>
                <!-- <td class="text-right">{{record.pay | numberFormat}}</td> -->
                <td class="text-right">{{record.principal | numberFormat}}</td>
                <td class="text-right">{{record.interest | numberFormat}}</td>
                <td class="text-right">{{record.delayInt | numberFormat}}</td>
                <td class="text-right">{{record.renge | numberFormat}}</td>
                <td>{{record.payment}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoanModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    loan: {
      type: Object,
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      records: []
    }
  },
  watch: {
    'loan': 'getLoan'
  },
  methods: {
    getLoan () {
      this.records = this.loan.intList
      //  bufferList.sort((a, b) => {
      //  return a.series > b.series ? 1:-1
      //  })
      //  this.records = bufferList.slice(0, bufferList.length > 5 ? 6: bufferList.length)
      this.records = this.records.sort(function(a, b){return b.series-a.series})
      // this.records = [
      //   {
      //     series: 1,
      //     last: 192667874,
      //     shouldPayAt: '106/06/07',
      //     payAt: '106/06/07',
      //     rate: '1.99',
      //     pay: 200000,
      //     payment: '轉帳(合作金庫6076)'
      //   }
      // ]
    }
  }
}
</script>